module.exports = __webpack_public_path__ + "static/media/190-Ipad-Banner@2x.b4b9bf9c.jpg";